










































































































































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import OnboardingInfo from '@/components/Stats/OnboardingStats/OnboardingInfo/index.vue';

@Component({
  components: {
    OnboardingInfo,
  },
})
export default class OnboardingTable extends Vue {
  @PropSync('onboardItems', {}) onboardItemSync!: [];

  @PropSync('onboardCount', {}) onboardCountSync!: [];

  @PropSync('selectedDateRange', {}) selectedDateRangeSync!: string;

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadingSync!: boolean;

  public tempOnboardItems: any;

  private seeList: boolean = false;

  private headers = [
    {
      text: 'Restaurant Name',
      align: 'left',
      value: 'name',
      width: '190px',
    },
    {
      text: 'Date',
      align: 'left',
      value: 'date',
      width: '190px',
    },
    {
      text: 'Market',
      align: 'left',
      value: 'market.name',
      width: '190px',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'status',
      width: '190px',
    },
  ];

  public get approvedPartners() {
    return this.onboardItemSync.filter((el: any) => el.status === 'Approved');
  }

  public get inProgressPartners() {
    return this.onboardItemSync.filter((el: any) => el.status === 'In-progress');
  }

  public get pendingApprovalPartners() {
    return this.onboardItemSync.filter((el: any) => el.status === 'Pending approval');
  }

  public onClickSee() {
    this.seeList = true;
  }
}
